import { z } from "zod";

import { CompanySchema } from "../../Company/schema/company";
import { CourseFileSchema, CourseTagSchema, JsonSchema } from "../../Courses/schema/courses";
import { CourseStatus } from "../../Courses/enums/CourseStatus.enum";

export const CourseSchema = z.object({
	id: z.number().gt(0),
	name: z.string(),
	json: JsonSchema.optional(),
	company: CompanySchema,
	description: z.string(),
	forWhom: z.string(),
	version: z.number().optional(),
	tag: CourseTagSchema.optional(),
	courseFiles: CourseFileSchema.array(),
	status: z.nativeEnum(CourseStatus),
});

export const UpdateCourseSchema = z.object({
	name: z.string(),
	json: JsonSchema.optional(),
});

export type CourseType = z.infer<typeof CourseSchema>;
export type UpdateCourse = z.infer<typeof UpdateCourseSchema>;
